<img src="assets/integrations/ifttt.svg" alt="">

<h5>{{'pageElements.iftttDesc' | translate}}</h5>

<button [ngClass]="{hidden: hasIFTTT}" (click)="goToIFTTT()" type="button"
        class="btn btn-new text-uppercase">{{'pageElements.connect' | translate}}</button>
<button [ngClass]="{hidden: !hasIFTTT}" (click)="goToIFTTT()" type="button"
        class="btn btn-cst-danger text-uppercase">{{'pageElements.disconnect' | translate}}</button>
